<template>
  <section>
    <!-- 按钮及日期行 -->
    <el-row style="padding:15px;background:#fff">
      <el-col :sm="12" :xs="24">
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" plain @click="changeDate(1)" id="today">昨天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)" id="seven">最近7天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
          
        </el-row>
      </el-col>
      <el-col :sm="12" :xs="24">
        <div style="float:right;text-align: right;">
        	 
          <el-row :gutter="10">
          	<!--<el-button class="xs24" type="primary" round @click="toogleChart" >图表</el-button>-->
            <el-select class="xs24" v-model="pdata.source" placeholder="请选择" @change="getList">
              <el-option label="全部" value=""></el-option>
              <el-option label="内部游戏" value="内部游戏"></el-option>
              <el-option label="外部游戏" value="外部游戏"></el-option>
            </el-select>

           	<searchApp class="xs24" @getid="changeId" compare="issued" ></searchApp>
            <el-button type="primary" @click="fieldConfig">字段选择</el-button>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 图表 --> 
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    
    <!--<el-table :data="cdata.list"   :height="height" style="width: 100%;min-width:1200px" stripe row-key="issued_app_id" :row-class-name="tableRowClassName" @expand-change="expands">
    	<el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]">
 			 	  	<template slot-scope="s"  > 
 			 	  			  <el-table :data="s.row.exData" :show-header="false" row-key="issued_app_id">
 			 	  			  	   <el-table-column  prop="issued_app_name" label="" align="center" width="48px">&nbsp;</el-table-column>
									      <el-table-column prop="d_date" label="日期" width="150px" align="center"></el-table-column>
									      <el-table-column prop="visit_uv" label="访问人数" align="center"  width="90px"></el-table-column>
									      <el-table-column prop="visit_uv_new" label="新增用户数" align="center"  width="90px"></el-table-column>
									     
									
									      <el-table-column label="收入" align="center">
									      	
											      	<el-table-column prop="total_flow" label="总流水" align="center" width="90px">
													         
											     		</el-table-column>
											     		
											        <el-table-column  prop="total_income" label="总收入" align="center" width="90px">
													        
											        </el-table-column>
											        
											        <el-table-column prop="" label="广告收入" align="center" >
											        	 <el-table-column  prop="origin_income"  label="流水" align="center" width="90px">
											        	 		
											        	 </el-table-column>
											        	 <el-table-column  prop="origin_divide_income"  label="发行分成" align="center" width="90px">
											        	 	
											        	 </el-table-column>
													      
											        </el-table-column>
											        
											         <el-table-column prop="origin_income" label="分发收入" align="center">
												         	<el-table-column  prop="matrix_income" label="矩阵" align="center" width="90px">
												        	 	
												        	</el-table-column>
												        	<el-table-column  prop="nonmatrix_income"  label="非矩阵" align="center" width="90px">
									
												        	 </el-table-column>
												         	<el-table-column  prop="distribution_income" label="合计" align="center" width="90px">
												        	 
												        	</el-table-column>
											         </el-table-column>
									         
									      </el-table-column>
									      <el-table-column label="支出" align="center">
									      	
									      	<el-table-column rop="total_cost"  label="总支出" align="center" width="90px">
									      		<template slot-scope="scope">{{scope.row.total_cost}}</template>
									      	</el-table-column>
									      	<el-table-column prop="cp_cost" label="cp分成" align="center" width="90px">
									      					
									      	</el-table-column>
									        <el-table-column  prop="expenses_cost" label="买量" align="center" width="90px">
									       
									        </el-table-column>
									        

									      </el-table-column>
												<el-table-column prop="profit"  label="利润" align="center" width="90px">
										
												</el-table-column>
									      <el-table-column prop="roi" label="ROI" align="center" width="90px">
									      	
									      </el-table-column>
									     
									      <el-table-column prop="arpu" label="单个用户价值" align="center" ></el-table-column>
									      
									      
									
					
 			 	  			  </el-table>
 			 	  	</template>
     </el-table-column>
      <el-table-column prop="issued_app_id" label="ID" width="50px" align="center"></el-table-column>
      <el-table-column prop="issued_app_name" label="小游戏名称" width="100px"  align="center"></el-table-column>
      <el-table-column prop="visit_uv" label="访问人数" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.visit_uv-0)-(b.visit_uv-0)}" ></el-table-column>
      <el-table-column prop="visit_uv_new" label="新增用户数" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}" ></el-table-column>
     

      <el-table-column label="收入" align="center">
      	
		      	<el-table-column prop="total_flow" label="总流水" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.total_flow-0)-(b.total_flow-0)}" >
				         
		     		</el-table-column>
		     		
		        <el-table-column  prop="total_income" label="总收入" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.total_income-0)-(b.total_income-0)}" >
				        
		        </el-table-column>
		        
		        <el-table-column prop="" label="广告收入" align="center" >
		        	 <el-table-column  prop="origin_income"  label="流水" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.origin_income-0)-(b.origin_income-0)}" >
		        	 		
		        	 </el-table-column>
		        	 <el-table-column  prop="origin_divide_income"  label="发行分成" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.origin_divide_income-0)-(b.origin_divide_income-0)}" >
		        	 	
		        	 </el-table-column>
				      
		        </el-table-column>
		        
		         <el-table-column prop="origin_income" label="分发收入" align="center">
			         	<el-table-column  prop="matrix_income" label="矩阵" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.matrix_income-0)-(b.matrix_income-0)}" >
			        	 	
			        	</el-table-column>
			        	<el-table-column  prop="nonmatrix_income"  label="非矩阵" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.nonmatrix_income-0)-(b.nonmatrix_income-0)}" >

			        	 </el-table-column>
			         	<el-table-column  prop="distribution_income" label="合计" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.distribution_income-0)-(b.distribution_income-0)}" >
			        	 
			        	</el-table-column>
		         </el-table-column>
         
      </el-table-column>
      <el-table-column label="支出" align="center">
      	
      	<el-table-column rop="total_cost"  label="总支出" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.total_cost-0)-(b.total_cost-0)}" >
      		<template slot-scope="scope">{{scope.row.total_cost}}</template>
      	</el-table-column>
      	<el-table-column prop="cp_cost" label="cp分成" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.cp_cost-0)-(b.cp_cost-0)}" >
      					
      	</el-table-column>
        <el-table-column  prop="expenses_cost" label="买量" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.expenses_cost-0)-(b.expenses_cost-0)}" >
       
        </el-table-column>
        

      </el-table-column>
			<el-table-column prop="profit"  label="利润" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.profit-0)-(b.profit-0)}" >
	
			</el-table-column>
      <el-table-column prop="roi" label="ROI" align="center" width="90px" sortable   :sort-method="(a,b)=>{return (a.roi-0)-(b.roi-0)}" >
      	
      </el-table-column>
     
      <el-table-column prop="arpu" label="单个用户价值" align="center" sortable   :sort-method="(a,b)=>{return (a.arpu-0)-(b.arpu-0)}" ></el-table-column>
      
      

      <el-table-column>
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({
          name:'更多数据',
          params:{issued_app_id:scope.row.issued_app_id,edate:pdata.edate,sdate:pdata.sdate}
        })"
          >更多数据</el-button>
        </template>
      </el-table-column>
    </el-table>-->
		
		<el-table :data="cdata.list" style="width: 100%;" stripe row-key="id" v-if="cdata.list.length>0">

			<el-table-column prop="issued_app_name" label="发行名称" align="center" min-width="120px"></el-table-column>

			<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList"  sortable :sort-method="(a,b)=>{return parseFloat(a[item.key]) - parseFloat(b[item.key])}">
				<template slot="header" slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="'截至'+pdata.edate+'的累计数据'" placement="top-start" v-if="item.key=='ltv'">
						<span>{{item.name}}<i class="el-icon-question"></i></span>
					</el-tooltip>
					<span v-else>{{item.name}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				 <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({name:'整体数据详情',params:{issued_app_id:scope.row.issued_app_id},query:{edate:pdata.edate,sdate:pdata.sdate}
        })"
          >详情</el-button>
        </template>
			</el-table-column>
		</el-table>

		<!--<el-table  style="width: 100%;" stripe row-key="id"  v-if="list.length==0"></el-table>-->
		<div class="el-table el-table--fit el-table--striped el-table--enable-row-hover" style="width: 100%;" v-if="cdata.list.length==0">
			<div class="el-table__body-wrapper is-scrolling-none">
				<div class="el-table__empty-block" style="height: 100%; width: 100%"><span class="el-table__empty-text">暂无数据</span></div>
			</div>
		</div>
    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80,200,500]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>

    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
    
    <el-drawer title="我是标题" size="580px" :visible.sync="drawer" direction="rtl" :with-header="false">
			<div class="filedFlex">
				<div class="fliedLeft">
					<div class="tit">设置显示字段</div>
					<div class="des">可选字段</div>
					<div class="fliedBtns" v-for="(value,key) in fieldList">
						<div class="key">{{key}}</div>
						<div class="btnsbox">

							<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTap(key,index)" :autofocus="false">{{item.name}}</el-button>

						</div>

					</div>
					<div class="fliedFt">
						<el-button type="success" @click="saveSelectField">确认并保存</el-button>
					</div>
				</div>
				<div class="fliedRight">
					<div class="tit">已选字段</div>
					<draggable v-model="selectFieldList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
						<transition-group type="transition" tag="ul">
							<li v-for="item in selectFieldList" :key="item.key" class="item">
								<i class="el-icon-rank"></i> {{item.name}}
								<i class="el-icon-close" @click="removeSelectField(item)"></i>
							</li>
						</transition-group>
					</draggable>
				</div>
			</div>
		</el-drawer>
  </section>
</template>

<script>
import $ from "jquery";	
import { getTotalData, getDetailData,getTotalDataDay,getfieldFilter, postfieldFilter, getValidProductPlatform } from "../../api/api";
import echarts from "echarts";
import draggable from 'vuedraggable'

export default {
	components: {
		draggable
	},
  data() {
    return {
    	isChartShow: true,
      chartColumn: null,
      timer:null,
      pdata: {
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-17",
        // edate: "2019-04-17",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: [
            "总访问人数",
            "总新增访问人数",
            "总收入",
            "利润",
            "买量成本",
            "ROI"
          ]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",

          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          { name: "总访问人数", type: "line", smooth: true, data: [] },
          { name: "总新增访问人数", type: "line", smooth: true, data: [] },
          { name: "总收入", type: "line", smooth: true, data: [] },
          { name: "利润", type: "line", smooth: true, data: [] },
          { name: "买量成本", type: "line", smooth: true, data: [] },
          { name: "ROI", type: "line", smooth: true, data: [] }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      },
      height:600,
      drawer: false, //默认不展开
      fieldList: {
					'用户数据': [{
							"name": "活跃用户",
							"key": "visit_uv",
							"isCheck": false
					},
						{
							"name": "注册用户",
							"key": "visit_uv_new",
							"isCheck": false
						},
					],
					'收入数据': [{
							"name": "总流水",
							"key": "total_flow",
							"isCheck": false
						},
						{
							"name": "总收入",
							"key": "total_income",
							"isCheck": false
						},
						{
							"name": "广告流水",
							"key": "origin_income",
							"isCheck": false
						},
						{
							"name": "广告发行分成",
							"key": "origin_divide_income",
							"isCheck": false
						},
						{
							"name": "分发矩阵收入",
							"key": "matrix_income",
							"isCheck": false
						},
						{
							"name": "分发非矩阵收入",
							"key": "nonmatrix_income",
							"isCheck": false
						},
						{
							"name": "分发合计",
							"key": "distribution_income",
							"isCheck": false
						}
					],
					'支出数据': [{
							"name": "总支出",
							"key": "total_cost",
							"isCheck": false
						},
						{
							"name": "cp分成",
							"key": "cp_cost",
							"isCheck": false
						},
						{
							"name": "买量",
							"key": "expenses_cost",
							"isCheck": false
						}
						
					],
					'分发数据': [

						{
							"name": "跳出率",
							"key": "jump_per",
							"isCheck": false
						},
						{
							"name": "换入活跃",
							"key": "huanliang_in",
							"isCheck": false
						},
						{
							"name": "换出活跃",
							"key": "huanliang_out",
							"isCheck": false
						},
						{
							"name": "分发收入（含矩阵）",
							"key": "distribution_income",
							"isCheck": false
						},
						{
							"name": "arpu（含矩阵）",
							"key": "distribution_day_contribution",
							"isCheck": false
						},
						{
							"name": "分发收入（不含矩阵）",
							"key": "nonmatrix_income",
							"isCheck": false
						},
						{
							"name": "arpu（不含矩阵）",
							"key": "nonmatrix_day_contribution",
							"isCheck": false
						},
						{
							"name": "总arpu",
							"key": "total_day_contribution",
							"isCheck": false
						}
					],
					'利润': [{
							"name": "利润",
							"key": "profit",
							"isCheck": false
						},
						{
							"name": "ROI",
							"key": "roi",
							"isCheck": false
						},
						{
							"name": "单个用户价值",
							"key": "arpu",
							"isCheck": false
						}
						
					]
				},
				selectFieldList: [],
				showFieldList: [],
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
  	getField() {
				console.log(this.pdata.platform_id)

				var _this = this;
				var p = "position=maindata_index";
				getfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					console.log(res.data.content);
					if(res.data.content == null || res.data.content.length == 0) {
						
						res.data.content = ['visit_uv', 'visit_uv_new','total_income','total_cost','profit','roi','arpu'];
					
					}
					_this.selectFieldList = [];
					_this.showFieldList = [];
					_this.list = [];
					res.data.content.forEach((vv, ii) => {
						for(var key in _this.fieldList) {
							_this.fieldList[key].forEach((v, i) => {

								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldList.push(v);
								}
							})
						}
					});
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getList();
				})
			},
			saveSelectField() {
				var tempArr = [];
				this.selectFieldList.forEach((v, i) => {
					tempArr.push(v.key);
				})
				var p = {
					position: 'maindata_index',
					content: tempArr,
				}
				postfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					this.drawer = false;
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getField();

				})
			},
			removeSelectField(obj) {
				this.removeArrForObjName(this.selectFieldList, obj);
				var fieldList_key;
				var fieldList_index;
				for(let key in this.fieldList) {
					this.fieldList[key].some((item, index) => {
						if(item.name == obj.name) {
							fieldList_key = key;
							this.fieldList[key][index].isCheck = false;

						}
					})
				}

			},
			onMove({
				relatedContext,
				draggedContext
			}) {
				const relatedElement = relatedContext.item;
				const draggedElement = draggedContext.item;
			},
			fieldConfig() {
				this.drawer = true
			},
			fliedTap(key, index) {
				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result = this.selectFieldList.some(item => {
					if(item.name == this.fieldList[key][index].name) {
						return true
					}
				})
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldList.push(this.fieldList[key][index])
					}
				} else {
					if(result) {
						this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index])
					}
				}
			},
			removeArrForObjName(_arr, _obj) {
				var length = _arr.length;
				for(var i = 0; i < length; i++) {
					if(_arr[i].name == _obj.name) {
						_arr.splice(i, 1); //删除下标为i的元素
						return _arr;
					}
				}
			},
  	 toogleChart() {
  	 	debugger;
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getTotalData(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	 if (res.data.list!=null&&res.data.list.length > 0) {
	            res.data.list.forEach((x,i) => {
	            	x.keyid='key'+i;
	              x.exData = [];
	            });
	            this.cdata = res.data;
	          }
        	 else{
        	 		 this.cdata = res.data;
        	 		 this.cdata.list=[];
        	 }
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
         
          this.maxPage = res.data.max_page;
          this.option.xAxis.data = res.data.chart.date;
          this.option.series[0].data = res.data.chart.visit_uv;
          this.option.series[1].data = res.data.chart.visit_uv_new;
          this.option.series[2].data = res.data.chart.total_income;
          this.option.series[3].data = res.data.chart.profit;
          this.option.series[4].data = res.data.chart.expenses_cost;
          this.option.series[5].data = res.data.chart.roi;
//        this.drawColumnChart();
        
          
        }
      });
    },
    changeId(res) {
			this.pdata.issued_app_id = res;
			this.getList();
		},
    tableRowClassName({ row, rowIndex }) {
//    if (row.clickok_uv == 0 && row.num != 0) {
//      return "warning-row";
//    }
      return "";
    },
    expands(r, es) {

      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `issued_app_id=${r.issued_app_id}&sdate=${this.dateVal[0]}&edate=${
          this.dateVal[1]
        }`;

        getTotalDataDay(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
            this.$forceUpdate();
          }
         
        });
      }
    },

    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    updateBuy(id){
      console.log(id)
    }
  },
  created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height() - 430;
  },
  update(){
 
  },

  mounted() {
  	
    this.getField()
    document.getElementById("today").focus();

    var _this=this;
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>

<style >
.total.el-row::before,
.total.el-row::after {
  content: table;
}
.total {
  min-width: 1200px;
  padding: 15px 10px;
  background: #f2f6fc;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  text-align: center;
}
.box-card {
  /* width: 260px; */
  margin: 10px;
  float: left;
}
.sicon {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 10px;
  border-radius: 10px;
  background: #67c23a;
  text-align: center;
  font-size: 25px;
  color: white;
}
.sicon.c1 {
  background: #67c23a;
}
.sicon.c2 {
  background: #409eff;
}
.sicon.c3 {
  background: #e6a23c;
}
.sicon.c4 {
  background: #f56c6c;
}
.sicon.c5 {
  background: #909399;
}

.tjContent {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  margin-left: 10px;
}
.tjContent > div {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
}

.tjContent > div.numText {
  font-size: 28px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: brown;
}
.tjContent > div.numText.t1 {
  color: #67c23a;
}
.tjContent > div.numText.t2 {
  color: #409eff;
}
.tjContent > div.numText.t3 {
  color: #e6a23c;
}
.tjContent > div.numText.t4 {
  color: #f56c6c;
}
.tjContent > div.numText.t5 {
  color: #909399;
}
</style>


<style>
	@media only screen and (max-width: 767px) {
	.total{
		min-width: 100% !important;
	}
	.xs24{
		width: 100% !important;
		margin: 5px 0;
	}
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 60px;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>

<style scoped="">
	.red {
		color: #FF0000;
	}
	
	.filedFlex {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 100%;
	}
	
	.fliedLeft {
		width: 360px;
		border-right: 1px solid #E6E6E6;
		box-sizing: border-box;
		height: 100%;
		height:calc(100vh - 70px);
		overflow-y: auto;
	}
	
	.fliedRight {
		width: 220px;
		height: 100%;
		height: 100vh;
		overflow-y: auto;
	}
	
	.tit {
		padding: 0 10px;
		text-align: left;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		border-bottom: 1px solid #E6E6E6;
	}
	
	.filedFlex .des {
		padding: 0 15px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
	}
	
	.filedFlex .key {
		padding: 0 15px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
		font-weight: bold;
	}
	
	.btnsbox {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding: 5px;
	}
	
	.btnsbox button {
		margin: 5px;
	}
	
	.btnsbox button:focus {}
	
	.fliedRight ul {
		margin: 0;
		padding: 0;
	}
	
	.fliedRight ul li {
		line-height: 40px;
		list-style: none;
		border-bottom: 1px solid #E6E6E6;
		padding: 0 10px;
	}
	
	.fliedRight ul li i {
		margin-right: 5px;
	}
	
	.fliedRight ul li i.el-icon-close {
		float: right;
		cursor: pointer;
		margin-top: 15px;
	}
	
	.fliedFt {
		margin: 20px 0;
		padding: 0 10px;
	}
</style>


// WEBPACK FOOTER //
// totalData.vue?1250a8bc